export default __webpack_public_path__ + "static/media/fileUpload.c07f1fbb.svg";